// Module
var code = `<div class="marketplace-contact animated fadeIn"> <div class="contact"> <ng-include src="'MarketplaceItemBody.html'"></ng-include> </div> </div>`;
// Exports
module.exports = code;